import type { WavespeedModelConfig } from '../../types';
import { clampTo } from '../../../tools';

export const nanoBananaConfigs: Record<string, WavespeedModelConfig> = {
    'nano-banana-2-lite/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-2-lite/text-to-image
        apiPath: '/google/nano-banana-2-lite/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:1', '1:4', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana-2-lite/edit': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-2-lite/edit
        apiPath: '/google/nano-banana-2-lite/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: size === 'match' ? 'auto' : clampTo(aspectRatio || '16:9', ['auto', '21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:1', '1:4', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                // 图片 URL
                images: image_urls.slice(0, 10),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana-2/text-to-image-fast': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-2/text-to-image-fast
        apiPath: '/google/nano-banana-2/text-to-image-fast',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:1', '1:4', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '2k', ['2k', '4k'] as const, '2k' ),
                // 可选参数
                enable_web_search: typeof providerOptions?.enable_web_search === 'boolean' ? providerOptions.enable_web_search : false,
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'nano-banana-2/edit-fast': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-pro/edit
        apiPath: '/google/nano-banana-2/edit-fast',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: size === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:1', '1:4', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '2k', ['2k', '4k'] as const, '2k' ),
                // 图片 URL
                images: image_urls.slice(0, 14),
                // 可选参数
                enable_web_search: typeof providerOptions?.enable_web_search === 'boolean' ? providerOptions.enable_web_search : false,
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'nano-banana-2/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-2/text-to-image
        apiPath: '/google/nano-banana-2/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:1', '1:4', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['0.5k', '1k', '2k', '4k'] as const, '1k'),
                // 可选参数
                enable_web_search: typeof providerOptions?.enable_web_search === 'boolean' ? providerOptions.enable_web_search : false,
                enable_image_search: typeof providerOptions?.enable_image_search === 'boolean' ? providerOptions.enable_image_search : false,
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana-2/edit': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-2/edit
        apiPath: '/google/nano-banana-2/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: size === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '8:1', '1:8', '5:4', '4:5', '4:1', '1:4', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['0.5k', '1k', '2k', '4k'] as const, '1k'),
                // 图片 URL
                images: image_urls.slice(0, 14),
                // 可选参数
                enable_web_search: typeof providerOptions?.enable_web_search === 'boolean' ? providerOptions.enable_web_search : false,
                enable_image_search: typeof providerOptions?.enable_image_search === 'boolean' ? providerOptions.enable_image_search : false,
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana-pro/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana-pro/text-to-image
        apiPath: '/google/nano-banana-pro/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['1k', '2k', '4k'] as const, '1k'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana-pro/edit': {
        // https://wavespeed.ai/models/google/nano-banana-pro/edit
        apiPath: '/google/nano-banana-pro/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: size === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                resolution: clampTo(image_resolution?.toLowerCase() || '1k', ['1k', '2k', '4k'] as const, '1k'),
                // 图片 URL
                images: image_urls.slice(0, 14),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana/text-to-image
        apiPath: '/google/nano-banana/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg'] as const,
                    'png',
                ),
            };
        },
    },
    'nano-banana/edit': {
        // https://wavespeed.ai/zh-CN/models/google/nano-banana/edit
        apiPath: '/google/nano-banana/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, size, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: size === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '16:9'] as const, '16:9'),
                // 图片 URL
                images: image_urls.slice(0, 10),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg'] as const,
                    'png',
                ),
            };
        },
    },
};